import { render, staticRenderFns } from "./add-video-modal.vue?vue&type=template&id=20e7e3be&scoped=true&"
import script from "./add-video-modal.vue?vue&type=script&lang=js&"
export * from "./add-video-modal.vue?vue&type=script&lang=js&"
import style0 from "./add-video-modal.vue?vue&type=style&index=0&id=20e7e3be&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20e7e3be",
  null
  
)

export default component.exports